module.exports = "<ul class=\"js-tabs-headers-region\"></ul>\n<div class=\"js-menu-button-region\"></div>\n";